import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { PORTFOLIO_OVERVIEW_CONVERTER_TOKEN, PortfolioOverviewConverter } from './portfolio-overview.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        portfolioOverviewFeature: {
          module: () => import('./portfolio-overview.module').then((m) => m.PortfolioOverviewModule),
          cmsComponents: ['portfolio']
        },
      }
    }),
    {
      provide: PORTFOLIO_OVERVIEW_CONVERTER_TOKEN,
      useExisting: PortfolioOverviewConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        portfolio: PORTFOLIO_OVERVIEW_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class PortfolioOverviewFeatureModule {}
